export type MappedNumericFilter = [number | null, number, string] | [];

export const mapNumericFilter = (value: string): MappedNumericFilter => {
  const [operator, val] = value.split('=');

  if (operator === '__range') {
    const [min, max] = val.split(',');

    return [+min, +max, operator];
  }

  if (val) {
    return [null, +val, operator];
  }

  return [];
};
